<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import UserForm from "./components/UserForm.vue"

defineProps<{
  user: {
    id?: number | null
    name: string
    email: string
    role_key: string
    company_id: number | ""
  }
  companies: Array<{ id: number; name: string }>
  role_options: Array<{ label: string; value: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <UserForm
      mode="create"
      title="Novo usuario"
      subtitle="Crie usuarios e defina perfil de acesso por empresa."
      :user="user"
      :companies="companies"
      :role-options="role_options"
      :errors="errors"
    />
  </AppShell>
</template>

